export default __webpack_public_path__ + "static/media/universal.05ce3162.jpg";